import {
  ADFORM_PUSH,
  ADFORM_PUSH_FAILED,
  ADFORM_PUSH_SUCCESS,
  GOOGLE_ADS_PUSH,
  GOOGLE_ADS_PUSH_SUCCESS,
  GOOGLE_ADS_PUSH_FAILED,
  TTD_PUSH,
  TTD_PUSH_FAILED,
  TTD_PUSH_SUCCESS,
  TTD_CLEAR_ERROR_STATE,
  XANDR_PUSH,
  XANDR_PUSH_SUCCESS,
  XANDR_PUSH_FAILED
} from "./constants";

// AdForm
export const adformPush = () => {
  return { type: ADFORM_PUSH };
};
export const adformPushSuccess = payload => {
  return { type: ADFORM_PUSH_SUCCESS, payload };
};
export const adformPushFailed = payload => {
  return { type: ADFORM_PUSH_FAILED, payload };
};

// Google Ads
export const googleAdsPush = () => {
  return { type: GOOGLE_ADS_PUSH };
};
export const googleAdsPushSuccess = payload => {
  return { type: GOOGLE_ADS_PUSH_SUCCESS, payload };
};
export const googleAdsPushFailed = payload => {
  return { type: GOOGLE_ADS_PUSH_FAILED, payload };
};

// TTD
export const ttdPush = () => {
  return { type: TTD_PUSH };
};

export const ttdPushFailed = payload => {
  return { type: TTD_PUSH_FAILED, payload };
};

export const ttdPushSuccess = payload => {
  return { type: TTD_PUSH_SUCCESS, payload };
};

export const ttdClearErrorState = () => {
  return { type: TTD_CLEAR_ERROR_STATE };
};

// Xandr
export const xandrPush = () => {
  return { type: XANDR_PUSH };
};
export const xandrPushSuccess = payload => {
  return { type: XANDR_PUSH_SUCCESS, payload };
};
export const xandrPushFailed = payload => {
  return { type: XANDR_PUSH_FAILED, payload };
};
